// Guard: snippet is rendered in every section so this script tag may
// be inserted multiple times on a single page. Browsers execute each
// occurrence — without this guard, all the animation IIFEs below would
// run N times in parallel and cripple performance.
if (window.__skyfallPmaxLoaded) { /* already initialized, skip */ } else {
window.__skyfallPmaxLoaded = true;

// Reduced-motion: draw one static frame instead of looping.
var SK_REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

// Visibility-gated rAF loop (same pattern as skyfall-surveillance.js):
// runs `frame` only while `el` intersects the viewport AND the tab is
// visible. Ungated infinite canvas loops were the page's main TBT source.
function skGateLoop(el, frame) {
  if (SK_REDUCE) { frame(); return; }
  var rafId = null, inView = false, pageVisible = !document.hidden;
  function loop() { frame(); rafId = requestAnimationFrame(loop); }
  function start() { if (rafId === null && inView && pageVisible) rafId = requestAnimationFrame(loop); }
  function stop() { if (rafId !== null) { cancelAnimationFrame(rafId); rafId = null; } }
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function(entries) {
      inView = entries[0].isIntersecting;
      if (inView) start(); else stop();
    }, { rootMargin: '80px' }).observe(el);
  } else { inView = true; start(); }
  document.addEventListener('visibilitychange', function() {
    pageVisible = !document.hidden;
    if (pageVisible) start(); else stop();
  });
}

// ═══ Crosshair cursor ═══
(function() {
  if (SK_REDUCE) return;
  if (window.matchMedia('(pointer: coarse)').matches) return;
  var ch = document.getElementById('crosshair');
  var x = 0, y = 0, tx = 0, ty = 0;
  document.addEventListener('mousemove', function(e) { tx = e.clientX; ty = e.clientY; ch.style.opacity = '0.7'; });
  document.addEventListener('mouseleave', function() { ch.style.opacity = '0'; });
  function loop() {
    x += (tx - x) * 0.2;
    y += (ty - y) * 0.2;
    ch.style.transform = 'translate(' + (x - 18) + 'px,' + (y - 18) + 'px)';
    requestAnimationFrame(loop);
  }
  loop();
})();

// ═══ Nav scroll state ═══
(function() {
  var nav = document.getElementById('nav');
  function onScroll() { nav.classList.toggle('is-scrolled', window.scrollY > 60); }
  window.addEventListener('scroll', onScroll, { passive: true });
})();

// ═══ Progress ring ═══
(function() {
  var bar = document.getElementById('progBar');
  var pct = document.getElementById('progPct');
  var circ = 2 * Math.PI * 27;
  function onScroll() {
    var max = document.documentElement.scrollHeight - window.innerHeight;
    var p = Math.max(0, Math.min(1, window.scrollY / max));
    bar.style.strokeDashoffset = circ * (1 - p);
    pct.textContent = Math.round(p * 100);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

// ═══ HERO CANVAS — particle field with cursor magnetism ═══
(function() {
  var c = document.getElementById('heroCanvas');
  var ctx = c.getContext('2d');
  var W = 0, H = 0, dpr = Math.min(window.devicePixelRatio || 1, 2);
  function resize() { var r = c.getBoundingClientRect(); W = r.width; H = r.height; c.width = W*dpr; c.height = H*dpr; ctx.setTransform(dpr,0,0,dpr,0,0); }
  resize(); window.addEventListener('resize', resize);

  // 110 points = ~6,000 pair-distance checks/frame; halve on small screens
  var N = window.innerWidth < 768 ? 55 : 110;
  var pts = [];
  for (var i = 0; i < N; i++) {
    // Higher initial velocity (~3× previous) so the field moves quickly even at rest
    pts.push({ x: Math.random()*W, y: Math.random()*H, vx: (Math.random()-0.5)*1.0, vy: (Math.random()-0.5)*1.0, r: Math.random()*1.6+0.4 });
  }
  var mx = -9999, my = -9999;
  document.addEventListener('mousemove', function(e) {
    var r = c.getBoundingClientRect();
    mx = e.clientX - r.left; my = e.clientY - r.top;
  });

  var t = 0;
  function tick() {
    t += 0.005;
    ctx.clearRect(0,0,W,H);

    // Slow gold gradient wash sweeping vertically
    var grad = ctx.createLinearGradient(0, H * 0.3, 0, H * 0.7 + Math.sin(t)*40);
    grad.addColorStop(0, 'rgba(146,188,221,0)');
    grad.addColorStop(0.5, 'rgba(146,188,221,0.04)');
    grad.addColorStop(1, 'rgba(146,188,221,0)');
    ctx.fillStyle = grad; ctx.fillRect(0, 0, W, H);

    // Update points — faster drift + much stronger cursor attraction
    for (var i = 0; i < pts.length; i++) {
      var p = pts[i];
      var dx = mx - p.x, dy = my - p.y;
      var d2 = dx*dx + dy*dy;
      // Range expanded 22500 → 90000 (3× radius). Force factor cut 4× from previous tuning.
      if (d2 < 90000) { var f = (1 - d2/90000) * 0.35; p.vx += dx*f*0.01; p.vy += dy*f*0.01; }
      p.x += p.vx; p.y += p.vy;
      // Lighter damping (0.99 → 0.985) so motion sustains longer
      p.vx *= 0.985; p.vy *= 0.985;
      if (p.x < 0) p.x = W; if (p.x > W) p.x = 0;
      if (p.y < 0) p.y = H; if (p.y > H) p.y = 0;
    }

    // Connections — brighter & longer-reaching so the animation reads
    for (var i = 0; i < pts.length; i++) {
      for (var j = i+1; j < pts.length; j++) {
        var a = pts[i], b = pts[j];
        var dx = a.x-b.x, dy = a.y-b.y;
        var d = dx*dx+dy*dy;
        if (d < 18000) {
          var op = (1 - d/18000) * 0.65;
          ctx.strokeStyle = 'rgba(146,188,221,' + op + ')';
          ctx.lineWidth = 0.8;
          ctx.beginPath(); ctx.moveTo(a.x,a.y); ctx.lineTo(b.x,b.y); ctx.stroke();
        }
      }
    }

    // Points — pulse cream highlights; baseline up so they're clearly visible
    for (var i = 0; i < pts.length; i++) {
      var p = pts[i];
      ctx.fillStyle = 'rgba(255,245,212,' + (0.75 + Math.sin(t*2 + i)*0.2) + ')';
      ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, Math.PI*2); ctx.fill();
    }
  }
  skGateLoop(c, tick);
})();

// ═══ Statement word-light reveal on scroll ═══
// Recursively wraps every descendant text node (any depth) in <span class="word">,
// skipping <em> accents and .statement__sig so they stay visible at all times.
// Robust to richtext <p><em>...</em>...</p> structures and to flat text+em.
function initPmaxStatement() {
  var s = document.getElementById('statement');
  if (!s) return;
  if (s.dataset.pmaxInit === '1') return;
  s.dataset.pmaxInit = '1';

  function wrapAllText(root) {
    var textNodes = [];
    (function walk(node) {
      Array.from(node.childNodes).forEach(function(child) {
        if (child.nodeType === 3) {
          if (child.textContent.trim().length) textNodes.push(child);
        } else if (child.nodeType === 1) {
          if (child.classList && child.classList.contains('statement__sig')) return;
          if (child.tagName === 'EM') return; // keep gold accents always visible
          walk(child);
        }
      });
    })(root);
    textNodes.forEach(function(tn) {
      var frag = document.createDocumentFragment();
      tn.textContent.split(/(\s+)/).forEach(function(w) {
        if (/^\s+$/.test(w)) {
          frag.appendChild(document.createTextNode(w));
        } else if (w.length) {
          var span = document.createElement('span');
          span.className = 'word';
          span.textContent = w;
          frag.appendChild(span);
        }
      });
      if (tn.parentNode) tn.parentNode.replaceChild(frag, tn);
    });
  }
  wrapAllText(s);

  var words = s.querySelectorAll('.word');
  if (!words.length) return;
  var section = s.closest('.chapter--tall') || s.closest('.chapter') || s.parentElement;

  function paint() {
    if (!section) return;
    var rect = section.getBoundingClientRect();
    var totalH = section.offsetHeight - window.innerHeight;
    var p;
    if (totalH > 0) {
      p = -rect.top / totalH;
    } else {
      var srect = s.getBoundingClientRect();
      p = 1 - (srect.top + srect.height * 0.3) / (window.innerHeight * 0.9);
    }
    p = Math.max(0, Math.min(1, p));
    var n = Math.floor(p * words.length);
    if (rect.top < window.innerHeight && rect.bottom > 0 && n < 1) n = 1;
    words.forEach(function(w, i) { w.classList.toggle('is-lit', i <= n); });
  }

  window.addEventListener('scroll', paint, { passive: true });
  window.addEventListener('resize', paint, { passive: true });

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries) {
      if (entries[0].isIntersecting) paint();
    }, { threshold: 0 });
    io.observe(section);
  }
  requestAnimationFrame(function() { requestAnimationFrame(paint); });
}

if (document.readyState === 'complete' || document.readyState === 'interactive') {
  initPmaxStatement();
} else {
  window.addEventListener('DOMContentLoaded', initPmaxStatement);
}
document.addEventListener('shopify:section:load', initPmaxStatement);

// ═══ Horizontal sequence scroll ═══
// Init waits for window.load so layout is fully settled (700vh sticky
// section needs accurate offsetHeight). Idempotent guard so repeat calls
// (resize / shopify:section:load) don't double-attach listeners.
function initPmaxSequence() {
  var section = document.getElementById('sequence');
  var rail = document.getElementById('seqRail');
  var dots = document.querySelectorAll('#seqIndicator span');
  if (!section || !rail) return;
  if (window.innerWidth < 1100) return;
  if (section.dataset.pmaxSeqInit === '1') return;
  section.dataset.pmaxSeqInit = '1';

  var panels = rail.children.length;

  function onScroll() {
    var rect = section.getBoundingClientRect();
    var sectionH = section.offsetHeight - window.innerHeight;
    if (sectionH <= 0) return;
    var p = Math.max(0, Math.min(1, -rect.top / sectionH));
    var eased;
    if (p < 0.08) eased = 0;
    else if (p > 0.92) eased = 1;
    else eased = (p - 0.08) / 0.84;
    var maxX = rail.scrollWidth - window.innerWidth;
    rail.style.transform = 'translateX(' + (-eased * maxX) + 'px)';
    var idx = Math.min(panels - 1, Math.floor(eased * panels + 0.05));
    dots.forEach(function(d, i) { d.classList.toggle('is-active', i === idx); });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  // Two RAFs to ensure layout settled before initial paint
  requestAnimationFrame(function() { requestAnimationFrame(onScroll); });
}
if (document.readyState === 'complete') {
  initPmaxSequence();
} else {
  window.addEventListener('load', initPmaxSequence);
}
document.addEventListener('shopify:section:load', initPmaxSequence);

// ═══ IntersectionObserver — reveal sections on scroll ═══
(function() {
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.reveal, .reveal-stagger').forEach(function(el) { el.classList.add('is-in'); });
    return;
  }
  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });
  document.querySelectorAll('.reveal, .reveal-stagger').forEach(function(el) { io.observe(el); });
})();

// ═══ Panel canvases — small viz per stage ═══
(function() {
  document.querySelectorAll('.panel-canvas').forEach(function(canvas) {
    var ctx = canvas.getContext('2d');
    var viz = canvas.dataset.viz;
    var W=0, H=0, dpr=Math.min(window.devicePixelRatio||1, 2);
    function resize() { var r=canvas.getBoundingClientRect(); W=r.width; H=r.height; canvas.width=W*dpr; canvas.height=H*dpr; ctx.setTransform(dpr,0,0,dpr,0,0); }
    resize(); window.addEventListener('resize', resize);

    var t = Math.random() * 100;
    // Lazy-init state for stateful viz types
    var accretionState = null;
    var creativeState = null;
    var signalState = null;
    var channelsState = null;
    var lockState = null;
    function tick() {
      t += 0.01;
      ctx.clearRect(0,0,W,H);
      var cx = W/2, cy = H/2;

      if (viz === 'signal') {
        // ─── Outer-space backdrop: starfield + nebula (matches Stages 2/4/5) ───
        if (!signalState) signalState = { stars: null, starsW: 0, starsH: 0 };
        if (!signalState.stars || signalState.starsW !== W || signalState.starsH !== H) {
          signalState.stars = []; signalState.starsW = W; signalState.starsH = H;
          var nSigStars = Math.round((W * H) / 1600);
          for (var sSig = 0; sSig < nSigStars; sSig++) {
            signalState.stars.push({
              x: Math.random() * W, y: Math.random() * H,
              r: Math.random() < 0.92 ? Math.random() * 0.7 + 0.3 : Math.random() * 1.4 + 1.2,
              tw: Math.random() * Math.PI * 2,
              base: 0.25 + Math.random() * 0.55,
              vx: (Math.random() - 0.5) * 0.04
            });
          }
        }
        var nebSigA = ctx.createRadialGradient(W*0.32, H*0.28, 0, W*0.32, H*0.28, Math.min(W,H)*0.85);
        nebSigA.addColorStop(0,    'rgba(146, 188, 221, 0.10)');
        nebSigA.addColorStop(0.35, 'rgba(120,  90,  50, 0.05)');
        nebSigA.addColorStop(1,    'rgba(0, 0, 0, 0)');
        ctx.fillStyle = nebSigA; ctx.fillRect(0, 0, W, H);
        var nebSigB = ctx.createRadialGradient(W*0.78, H*0.75, 0, W*0.78, H*0.75, Math.min(W,H)*0.7);
        nebSigB.addColorStop(0,   'rgba(80, 90, 130, 0.08)');
        nebSigB.addColorStop(0.4, 'rgba(40, 50, 80, 0.04)');
        nebSigB.addColorStop(1,   'rgba(0, 0, 0, 0)');
        ctx.fillStyle = nebSigB; ctx.fillRect(0, 0, W, H);
        for (var sSig2 = 0; sSig2 < signalState.stars.length; sSig2++) {
          var stSig = signalState.stars[sSig2];
          stSig.x += stSig.vx;
          if (stSig.x < -2) stSig.x = W + 2;
          if (stSig.x > W + 2) stSig.x = -2;
          var twSig = stSig.base + Math.sin(t * 1.4 + stSig.tw) * 0.28;
          twSig = Math.max(0.05, Math.min(1, twSig));
          if (stSig.r > 1.0) {
            ctx.fillStyle = 'rgba(255, 245, 212, ' + (twSig * 0.4) + ')';
            ctx.beginPath(); ctx.arc(stSig.x, stSig.y, stSig.r * 2.6, 0, Math.PI*2); ctx.fill();
          }
          ctx.fillStyle = 'rgba(255, 245, 212, ' + twSig + ')';
          ctx.beginPath(); ctx.arc(stSig.x, stSig.y, stSig.r, 0, Math.PI*2); ctx.fill();
        }
        // ─── Subtle grid backdrop (above stars, behind the wavefield) ───
        ctx.strokeStyle = 'rgba(236,237,238,0.035)';
        ctx.lineWidth = 0.5;
        var gstep = 28;
        for (var gx = (gstep/2); gx <= W; gx += gstep) {
          ctx.beginPath(); ctx.moveTo(gx, 0); ctx.lineTo(gx, H); ctx.stroke();
        }
        for (var gy = (gstep/2); gy <= H; gy += gstep) {
          ctx.beginPath(); ctx.moveTo(0, gy); ctx.lineTo(W, gy); ctx.stroke();
        }
        // ─── Iridescent stacked wavelength field ───
        // Many parallel curves morph through one another, bell-curve envelope
        // so the field is densest at center and tapers off at the edges.
        var N = 48;
        ctx.lineWidth = 0.5;
        ctx.lineCap = 'round';
        // Per-x horizontal gradient — runs through the champagne palette so
        // the wave reads iridescent without leaving the brand.
        var grad = ctx.createLinearGradient(0, 0, W, 0);
        grad.addColorStop(0,    'rgba(160, 134, 73, 0.0)');
        grad.addColorStop(0.08, 'rgba(160, 134, 73, 0.55)');
        grad.addColorStop(0.35, 'rgba(146, 188, 221, 0.85)');
        grad.addColorStop(0.55, 'rgba(235, 217, 168, 1.0)');
        grad.addColorStop(0.78, 'rgba(146, 188, 221, 0.85)');
        grad.addColorStop(0.92, 'rgba(160, 134, 73, 0.55)');
        grad.addColorStop(1,    'rgba(160, 134, 73, 0.0)');
        ctx.strokeStyle = grad;
        for (var i = 0; i < N; i++) {
          var iN = i / (N - 1);          // 0..1 across stack
          var sym = (iN - 0.5) * 2;      // -1..1
          var phase = iN * 1.4 + t * 3.6; // 4× faster motion
          var lateral = sym * H * 0.08;  // narrower vertical fan-out
          ctx.beginPath();
          for (var x = 0; x <= W; x += 3) {
            // Bell-curve envelope: tall middle, soft taper at edges
            var nx = (x - W*0.5) / (W*0.42);
            var env = Math.exp(-nx*nx) * (1 - Math.abs(sym)*0.35);
            var amp = H * 0.11 * env;    // ~3× shallower so wave travels linearly
            // Sum three frequencies for organic morphing — kept as traveling wave
            var y = cy + lateral
              + Math.sin(x*0.012 + phase)            * amp
              + Math.sin(x*0.028 + phase*1.3 + iN*2) * amp * 0.40
              + Math.sin(x*0.005 + phase*0.55)       * amp * 0.25;
            if (x === 0) ctx.moveTo(x, y); else ctx.lineTo(x, y);
          }
          ctx.globalAlpha = 0.18 + Math.abs(sym) * 0.22 + (1 - Math.abs(sym)) * 0.55;
          ctx.stroke();
        }
        ctx.globalAlpha = 1;
        ctx.lineCap = 'butt';
        // ─── Subtle static — random speckle layer on top, like RF noise ───
        for (var s = 0; s < 220; s++) {
          ctx.fillStyle = 'rgba(235,217,168,' + (0.04 + Math.random() * 0.18) + ')';
          ctx.fillRect(Math.random() * W, Math.random() * H, 1, 1);
        }
      } else if (viz === 'audience') {
        // ─── Particle accretion: audiences compounding into one core ───
        if (!accretionState) {
          accretionState = { parts: [], mass: 0, pulseT: 0 };
        }
        var S = accretionState;
        // ─── Outer-space backdrop: nebula glow + twinkling starfield ───
        if (!S.stars || S.starsW !== W || S.starsH !== H) {
          S.stars = [];
          S.starsW = W; S.starsH = H;
          var nStars = Math.round((W * H) / 1600); // density-based
          for (var sIdx = 0; sIdx < nStars; sIdx++) {
            S.stars.push({
              x: Math.random() * W,
              y: Math.random() * H,
              // ~8% bright stars (with halo), 92% pinpricks
              r: Math.random() < 0.92 ? Math.random() * 0.7 + 0.3 : Math.random() * 1.4 + 1.2,
              tw: Math.random() * Math.PI * 2,
              base: 0.25 + Math.random() * 0.55,
              vx: (Math.random() - 0.5) * 0.04 // gentle parallax drift
            });
          }
        }
        // Faint off-center nebula cloud
        var nebGrad = ctx.createRadialGradient(W*0.32, H*0.28, 0, W*0.32, H*0.28, Math.min(W,H)*0.85);
        nebGrad.addColorStop(0,    'rgba(146, 188, 221, 0.10)');
        nebGrad.addColorStop(0.35, 'rgba(120,  90,  50, 0.05)');
        nebGrad.addColorStop(1,    'rgba(0, 0, 0, 0)');
        ctx.fillStyle = nebGrad;
        ctx.fillRect(0, 0, W, H);
        // A second cooler nebula tint in the opposite corner for depth
        var nebGrad2 = ctx.createRadialGradient(W*0.78, H*0.75, 0, W*0.78, H*0.75, Math.min(W,H)*0.7);
        nebGrad2.addColorStop(0,   'rgba(80, 90, 130, 0.08)');
        nebGrad2.addColorStop(0.4, 'rgba(40, 50, 80, 0.04)');
        nebGrad2.addColorStop(1,   'rgba(0, 0, 0, 0)');
        ctx.fillStyle = nebGrad2;
        ctx.fillRect(0, 0, W, H);
        // Twinkling stars
        for (var sIdx = 0; sIdx < S.stars.length; sIdx++) {
          var st = S.stars[sIdx];
          // Slow drift; wrap horizontally so the field never empties
          st.x += st.vx;
          if (st.x < -2) st.x = W + 2;
          if (st.x > W + 2) st.x = -2;
          var twAlpha = st.base + Math.sin(t * 1.4 + st.tw) * 0.28;
          twAlpha = Math.max(0.05, Math.min(1, twAlpha));
          if (st.r > 1.0) {
            // Bright star — soft halo behind it
            ctx.fillStyle = 'rgba(255, 245, 212, ' + (twAlpha * 0.4) + ')';
            ctx.beginPath(); ctx.arc(st.x, st.y, st.r * 2.6, 0, Math.PI*2); ctx.fill();
          }
          ctx.fillStyle = 'rgba(255, 245, 212, ' + twAlpha + ')';
          ctx.beginPath(); ctx.arc(st.x, st.y, st.r, 0, Math.PI*2); ctx.fill();
        }
        // Spawn fresh particles at the edges, drifting toward center
        for (var k = 0; k < 2; k++) {
          if (S.parts.length < 90 && Math.random() < 0.85) {
            var edge = Math.floor(Math.random() * 4);
            var sx, sy;
            if      (edge === 0) { sx = Math.random()*W; sy = -8; }
            else if (edge === 1) { sx = W+8;             sy = Math.random()*H; }
            else if (edge === 2) { sx = Math.random()*W; sy = H+8; }
            else                 { sx = -8;              sy = Math.random()*H; }
            var dx = cx - sx, dy = cy - sy;
            var d = Math.sqrt(dx*dx + dy*dy) || 1;
            var tx = -dy/d, ty = dx/d;
            var spd = 0.6 + Math.random()*0.4;
            // Smaller tangential nudge so initial trajectory points at the core
            var tang = (Math.random() - 0.5) * 0.35;
            S.parts.push({
              x: sx, y: sy,
              vx: (dx/d) * spd + tx * tang,
              vy: (dy/d) * spd + ty * tang,
              r: 0.8 + Math.random() * 1.0,
              trail: []
            });
          }
        }
        // Unbounded growth — core radius keeps climbing as mass accumulates
        var coreR = Math.sqrt(S.mass) * 1.8 + 6;
        var capR = coreR + 4;
        for (var i = S.parts.length - 1; i >= 0; i--) {
          var p = S.parts[i];
          var pdx = cx - p.x, pdy = cy - p.y;
          var pd2 = pdx*pdx + pdy*pdy;
          // Stronger pull (3× cap), so no particle has the energy to escape
          var pullStrength = Math.min(1.0, 4000 / (pd2 + 80));
          p.vx += (pdx) * 0.003 * pullStrength;
          p.vy += (pdy) * 0.003 * pullStrength;
          // Light damping so escape velocity is impossible to build up
          p.vx *= 0.99; p.vy *= 0.99;
          // Cap velocity to keep trajectories controlled
          var sp2 = p.vx*p.vx + p.vy*p.vy;
          if (sp2 > 25) {
            var sf = 5 / Math.sqrt(sp2);
            p.vx *= sf; p.vy *= sf;
          }
          p.trail.push({ x: p.x, y: p.y });
          if (p.trail.length > 6) p.trail.shift();
          p.x += p.vx; p.y += p.vy;
          if (pd2 < capR*capR) {
            S.mass += 1;
            S.parts.splice(i, 1);
            continue;
          }
          // If somehow off-screen, redirect back toward core instead of pruning
          if (p.x < -40 || p.x > W+40 || p.y < -40 || p.y > H+40) {
            var rd = Math.sqrt(pd2) || 1;
            p.x = cx - (pdx/rd) * Math.min(W,H) * 0.45;
            p.y = cy - (pdy/rd) * Math.min(W,H) * 0.45;
            p.vx = (pdx/rd) * 1.2;
            p.vy = (pdy/rd) * 1.2;
          }
          for (var tIdx = 0; tIdx < p.trail.length - 1; tIdx++) {
            var a1 = p.trail[tIdx], a2 = p.trail[tIdx+1];
            var alpha = (tIdx / p.trail.length) * 0.5;
            ctx.strokeStyle = 'rgba(146,188,221,' + alpha + ')';
            ctx.lineWidth = 0.6;
            ctx.beginPath(); ctx.moveTo(a1.x, a1.y); ctx.lineTo(a2.x, a2.y); ctx.stroke();
          }
          ctx.fillStyle = 'rgba(255,245,212,0.9)';
          ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, Math.PI*2); ctx.fill();
        }
        // No mass reset — core grows continuously for the full session
        S.pulseT += 0.06;
        var pulse = 1 + Math.sin(S.pulseT) * 0.06;
        var grad2 = ctx.createRadialGradient(cx, cy, 0, cx, cy, coreR * 3);
        grad2.addColorStop(0,    'rgba(235,217,168,0.55)');
        grad2.addColorStop(0.25, 'rgba(146,188,221,0.22)');
        grad2.addColorStop(1,    'rgba(146,188,221,0)');
        ctx.fillStyle = grad2;
        ctx.beginPath(); ctx.arc(cx, cy, coreR * 3, 0, Math.PI*2); ctx.fill();
        // Rings keep adding as the core gathers more mass — no cap
        var rings = Math.floor(S.mass / 6);
        for (var ri = 0; ri < rings; ri++) {
          var rr = coreR * 0.5 + ri * 6 * pulse;
          ctx.strokeStyle = 'rgba(146,188,221,' + (0.35 - ri*0.04) + ')';
          ctx.lineWidth = ri === 0 ? 1.4 : 0.7;
          ctx.beginPath(); ctx.arc(cx, cy, rr, 0, Math.PI*2); ctx.stroke();
        }
        ctx.fillStyle = '#e0ecf7';
        ctx.shadowColor = 'rgba(255,245,212,0.9)'; ctx.shadowBlur = 16;
        ctx.beginPath(); ctx.arc(cx, cy, coreR * 0.5 * pulse, 0, Math.PI*2); ctx.fill();
        ctx.shadowBlur = 0;
      } else if (viz === 'creative') {
        // ─── Vertical cinema strip: creative variants scroll upward through
        //     a center evaluation gate. Each frame is judged ✓ APPROVED or
        //     ✕ REJECT as it crosses; rejects dim, approvals flash champagne. ───
        var frameH = 64, gap = 8;
        var stripPad = 26, stripW = W - stripPad * 2;
        var scrollSpeed = 0.55;
        if (!creativeState) {
          creativeState = { frames: [], nextId: 1, perfOffset: 0 };
          // Pre-populate the panel with frames spanning above/below view; mark
          // already-past-gate frames as evaluated so the strip looks lived-in
          for (var seedI = 0; seedI < 8; seedI++) {
            var sy = -frameH + seedI * (frameH + gap);
            var sf = {
              y: sy,
              pattern: Math.floor(Math.random() * 4),
              morph: Math.random() * Math.PI * 2,
              id: creativeState.nextId++,
              evaluated: false, verdict: null, flashT: 0
            };
            if (sy + frameH / 2 < H / 2) {
              sf.evaluated = true;
              sf.verdict = Math.random() < 0.45 ? 'win' : 'fail';
            }
            creativeState.frames.push(sf);
          }
        }
        var Cs = creativeState;
        // Update: scroll up, evaluate at gate, prune off top, spawn at bottom
        for (var fi = Cs.frames.length - 1; fi >= 0; fi--) {
          var f = Cs.frames[fi];
          f.y -= scrollSpeed;
          f.morph += 0.018;
          // Evaluation gate: when frame center crosses cy from below
          if (!f.evaluated && (f.y + frameH/2) < cy) {
            f.evaluated = true;
            var roll = Math.random();
            if (roll < 0.32) { f.verdict = 'win'; f.flashT = 1; }
            else if (roll < 0.7) { f.verdict = 'fail'; }
            // ~30% pass through neutral
          }
          if (f.flashT > 0) f.flashT *= 0.96;
          if (f.y + frameH < 0) Cs.frames.splice(fi, 1);
        }
        // Spawn replacements at bottom
        var lowestY = -Infinity;
        for (var fi2 = 0; fi2 < Cs.frames.length; fi2++) {
          if (Cs.frames[fi2].y > lowestY) lowestY = Cs.frames[fi2].y;
        }
        if (lowestY < H + gap) {
          Cs.frames.push({
            y: lowestY + frameH + gap,
            pattern: Math.floor(Math.random() * 4),
            morph: Math.random() * Math.PI * 2,
            id: Cs.nextId++,
            evaluated: false, verdict: null, flashT: 0
          });
        }
        // ─── Film perforations on left + right edges ───
        Cs.perfOffset = (Cs.perfOffset + scrollSpeed) % 14;
        ctx.fillStyle = 'rgba(146, 188, 221, 0.20)';
        for (var py = -14; py < H + 14; py += 14) {
          var ay = py - Cs.perfOffset;
          ctx.fillRect(8, ay, 4, 7);
          ctx.fillRect(W - 12, ay, 4, 7);
        }
        // ─── Render frames ───
        for (var fi3 = 0; fi3 < Cs.frames.length; fi3++) {
          var fr = Cs.frames[fi3];
          var fy = fr.y;
          if (fy + frameH < -2 || fy > H + 2) continue;
          var ax = (fr.verdict === 'fail') ? 0.30 : 1;
          // Card backdrop
          ctx.fillStyle = 'rgba(7, 8, 11, ' + (0.55 * ax) + ')';
          ctx.fillRect(stripPad, fy, stripW, frameH);
          // Pattern
          ctx.save();
          ctx.beginPath(); ctx.rect(stripPad + 4, fy + 4, stripW - 8, frameH - 8); ctx.clip();
          var lc = 'rgba(235, 217, 168, ' + (0.85 * ax) + ')';
          if (fr.pattern === 0) {
            ctx.strokeStyle = lc; ctx.lineWidth = 0.7;
            for (var pi = 0; pi < 6; pi++) {
              var ly = fy + 10 + (pi / 5) * (frameH - 20) + Math.sin(fr.morph + pi * 0.4) * 1.2;
              ctx.beginPath(); ctx.moveTo(stripPad + 12, ly); ctx.lineTo(stripPad + stripW - 12, ly); ctx.stroke();
            }
          } else if (fr.pattern === 1) {
            ctx.fillStyle = lc;
            for (var pi = 0; pi < 8; pi++) {
              for (var pj = 0; pj < 3; pj++) {
                var dx = stripPad + 14 + pi * (stripW - 28) / 7;
                var dy = fy + 14 + pj * (frameH - 28) / 2;
                ctx.beginPath(); ctx.arc(dx, dy, 1.4 + Math.sin(fr.morph + pi + pj) * 0.3, 0, Math.PI*2); ctx.fill();
              }
            }
          } else if (fr.pattern === 2) {
            ctx.strokeStyle = lc; ctx.lineWidth = 0.6;
            for (var pi = -3; pi < 14; pi++) {
              var hx = stripPad + (pi / 9) * stripW + Math.sin(fr.morph + pi) * 1.0;
              ctx.beginPath();
              ctx.moveTo(hx, fy); ctx.lineTo(hx + frameH, fy + frameH); ctx.stroke();
            }
          } else {
            var bg = ctx.createLinearGradient(stripPad, fy, stripPad + stripW, fy + frameH);
            var mid = 0.5 + Math.sin(fr.morph) * 0.25;
            bg.addColorStop(0,   'rgba(160, 134, 73, ' + (0.4 * ax) + ')');
            bg.addColorStop(mid, 'rgba(235, 217, 168, ' + (0.85 * ax) + ')');
            bg.addColorStop(1,   'rgba(160, 134, 73, ' + (0.4 * ax) + ')');
            ctx.fillStyle = bg;
            ctx.fillRect(stripPad + 8, fy + 8, stripW - 16, frameH - 16);
          }
          ctx.restore();
          // Border + winner glow
          if (fr.flashT > 0.05) {
            ctx.strokeStyle = 'rgba(255, 245, 212, ' + (0.95 * fr.flashT) + ')';
            ctx.lineWidth = 1.6;
            ctx.shadowColor = 'rgba(255, 245, 212, 0.95)'; ctx.shadowBlur = 16;
            ctx.strokeRect(stripPad + 0.5, fy + 0.5, stripW - 1, frameH - 1);
            ctx.shadowBlur = 0;
          } else {
            ctx.strokeStyle = 'rgba(146, 188, 221, ' + (0.4 * ax) + ')';
            ctx.lineWidth = 0.7;
            ctx.strokeRect(stripPad + 0.5, fy + 0.5, stripW - 1, frameH - 1);
          }
          // ID label (top-left)
          ctx.fillStyle = 'rgba(146, 188, 221, ' + (0.6 * ax) + ')';
          ctx.font = '8px JetBrains Mono, monospace';
          ctx.textAlign = 'left';
          ctx.fillText('V·' + ('000' + fr.id).slice(-3), stripPad + 8, fy + 13);
          // Verdict stamp (top-right)
          if (fr.evaluated && fr.verdict) {
            ctx.textAlign = 'right';
            if (fr.verdict === 'win') {
              ctx.fillStyle = 'rgba(235, 217, 168, ' + (0.9 * ax) + ')';
              ctx.fillText('APPROVED', stripPad + stripW - 8, fy + 13);
            } else {
              ctx.fillStyle = 'rgba(146, 188, 221, ' + (0.45 * ax) + ')';
              ctx.fillText('REJECT', stripPad + stripW - 8, fy + 13);
            }
          }
        }
        // ─── Evaluation gate at panel center ───
        ctx.strokeStyle = 'rgba(255, 245, 212, 0.55)';
        ctx.lineWidth = 1;
        ctx.setLineDash([3, 3]);
        ctx.beginPath();
        ctx.moveTo(0, cy); ctx.lineTo(W, cy);
        ctx.stroke();
        ctx.setLineDash([]);
        ctx.fillStyle = 'rgba(146, 188, 221, 0.85)';
        ctx.font = '8px JetBrains Mono, monospace';
        ctx.textAlign = 'left';
        ctx.fillText('▸ EVAL', 14, cy - 5);
      } else if (viz === 'channels') {
        // ─── Polygon morph in deep space: 8 channels as octagon vertices,
        //     each radius pulsing on its own phase/frequency. Constant motion,
        //     never snaps back to symmetry. Starfield + nebula backdrop. ───
        if (!channelsState) {
          var lbls = ['SEARCH','SHOPPING','YT','DISPLAY','GMAIL','MAPS','DISCOVER','PARTNERS'];
          channelsState = { verts: [], stars: null, starsW: 0, starsH: 0 };
          for (var ci = 0; ci < 8; ci++) {
            channelsState.verts.push({
              angle: -Math.PI/2 + (ci/8) * Math.PI*2,
              phase: Math.random() * Math.PI * 2,
              // Slightly varied speeds across vertices keep the polygon
              // perpetually morphing — they never realign because their
              // periods are incommensurate.
              speed: 1.8 + Math.random() * 2.4,
              amp: 0.20 + Math.random() * 0.20,
              label: lbls[ci]
            });
          }
        }
        var Cx = channelsState;
        // ─── Outer-space backdrop: starfield + nebula (matches Stage 2) ───
        if (!Cx.stars || Cx.starsW !== W || Cx.starsH !== H) {
          Cx.stars = []; Cx.starsW = W; Cx.starsH = H;
          var nStars = Math.round((W * H) / 1600);
          for (var sIdx = 0; sIdx < nStars; sIdx++) {
            Cx.stars.push({
              x: Math.random() * W, y: Math.random() * H,
              r: Math.random() < 0.92 ? Math.random() * 0.7 + 0.3 : Math.random() * 1.4 + 1.2,
              tw: Math.random() * Math.PI * 2,
              base: 0.25 + Math.random() * 0.55,
              vx: (Math.random() - 0.5) * 0.04
            });
          }
        }
        // Warm gold nebula upper-left
        var nebA = ctx.createRadialGradient(W*0.32, H*0.28, 0, W*0.32, H*0.28, Math.min(W,H)*0.85);
        nebA.addColorStop(0,    'rgba(146, 188, 221, 0.10)');
        nebA.addColorStop(0.35, 'rgba(120,  90,  50, 0.05)');
        nebA.addColorStop(1,    'rgba(0, 0, 0, 0)');
        ctx.fillStyle = nebA; ctx.fillRect(0, 0, W, H);
        // Cool blue nebula lower-right
        var nebB = ctx.createRadialGradient(W*0.78, H*0.75, 0, W*0.78, H*0.75, Math.min(W,H)*0.7);
        nebB.addColorStop(0,   'rgba(80, 90, 130, 0.08)');
        nebB.addColorStop(0.4, 'rgba(40, 50, 80, 0.04)');
        nebB.addColorStop(1,   'rgba(0, 0, 0, 0)');
        ctx.fillStyle = nebB; ctx.fillRect(0, 0, W, H);
        // Twinkling stars with parallax drift
        for (var sIdx = 0; sIdx < Cx.stars.length; sIdx++) {
          var st = Cx.stars[sIdx];
          st.x += st.vx;
          if (st.x < -2) st.x = W + 2;
          if (st.x > W + 2) st.x = -2;
          var twA = st.base + Math.sin(t * 1.4 + st.tw) * 0.28;
          twA = Math.max(0.05, Math.min(1, twA));
          if (st.r > 1.0) {
            ctx.fillStyle = 'rgba(255, 245, 212, ' + (twA * 0.4) + ')';
            ctx.beginPath(); ctx.arc(st.x, st.y, st.r * 2.6, 0, Math.PI*2); ctx.fill();
          }
          ctx.fillStyle = 'rgba(255, 245, 212, ' + twA + ')';
          ctx.beginPath(); ctx.arc(st.x, st.y, st.r, 0, Math.PI*2); ctx.fill();
        }
        // ─── Polygon morph (constant motion, never snaps to symmetry) ───
        var R = Math.min(W, H) * 0.30;
        var positions = [];
        for (var ci = 0; ci < 8; ci++) {
          var v = Cx.verts[ci];
          var rActual = R * (1 + Math.sin(t * v.speed + v.phase) * v.amp);
          positions.push({
            x: cx + Math.cos(v.angle) * rActual,
            y: cy + Math.sin(v.angle) * rActual
          });
        }
        // Polygon outline
        ctx.strokeStyle = 'rgba(235, 217, 168, 0.7)';
        ctx.lineWidth = 1.2;
        ctx.shadowColor = 'rgba(255, 245, 212, 0.4)'; ctx.shadowBlur = 6;
        ctx.beginPath();
        ctx.moveTo(positions[0].x, positions[0].y);
        for (var ci = 1; ci < 8; ci++) ctx.lineTo(positions[ci].x, positions[ci].y);
        ctx.closePath();
        ctx.stroke();
        ctx.shadowBlur = 0;
        // Vertex dots
        for (var ci = 0; ci < 8; ci++) {
          var pp2 = positions[ci];
          ctx.fillStyle = 'rgba(255, 245, 212, 0.85)';
          ctx.shadowColor = 'rgba(255, 245, 212, 0.7)'; ctx.shadowBlur = 8;
          ctx.beginPath(); ctx.arc(pp2.x, pp2.y, 3.4, 0, Math.PI*2); ctx.fill();
          ctx.shadowBlur = 0;
        }
        // Channel labels follow each vertex — push outward along the
        // center→vertex direction so they ride the morph in real time.
        ctx.fillStyle = 'rgba(235, 217, 168, 0.95)';
        ctx.font = '11px JetBrains Mono, monospace';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        for (var ci = 0; ci < 8; ci++) {
          var v2 = Cx.verts[ci];
          var ppL = positions[ci];
          var ldx = ppL.x - cx, ldy = ppL.y - cy;
          var ldist = Math.sqrt(ldx*ldx + ldy*ldy) || 1;
          var lx = ppL.x + (ldx / ldist) * 16;
          var ly = ppL.y + (ldy / ldist) * 16;
          ctx.fillText(v2.label, lx, ly);
        }
        ctx.textAlign = 'left';
        ctx.textBaseline = 'alphabetic';
        // Center hub dot
        ctx.shadowColor = 'rgba(255, 245, 212, 0.7)'; ctx.shadowBlur = 8;
        ctx.fillStyle = 'rgba(235, 217, 168, 0.95)';
        ctx.beginPath(); ctx.arc(cx, cy, 3, 0, Math.PI*2); ctx.fill();
        ctx.shadowBlur = 0;
      } else if (viz === 'lock') {
        // ─── Continuous, ever-growing ROAS chart. Starts BLANK and fills in
        //     from the right edge as live samples arrive. Strictly monotonic
        //     upward — every new sample is higher than the last. ───
        if (!lockState) {
          lockState = {
            points: [],          // empty — fills in over time
            events: [], revenue: 0,
            scroll: 0, eventTimer: 30,
            viewMin: undefined, viewMax: undefined,
            pxSpacing: 3         // pixels per sample
          };
        }
        var Lk = lockState;
        var maxPts = Math.ceil(W / Lk.pxSpacing) + 4;
        var chartTop = H * 0.10, chartBot = H * 0.88;
        // Continuous scroll + new sample tick (every 4 frames)
        Lk.scroll += Lk.pxSpacing / 4;
        if (Lk.scroll >= Lk.pxSpacing) {
          Lk.scroll -= Lk.pxSpacing;
          var lastRoas = Lk.points.length > 0 ? Lk.points[Lk.points.length - 1] : 4.0;
          var step = 0.003 + Math.random() * 0.035;
          if (Math.random() < 0.06) step += Math.random() * 0.08; // rare surge
          var newRoas = lastRoas + step;
          Lk.points.push(newRoas);
          while (Lk.points.length > maxPts) Lk.points.shift();
        }
        var nPts = Lk.points.length;
        var floorRoas = 4.0;
        // Auto-scale Y-axis to preserve a visible upward angle. Anchor the
        // bottom near the OLDEST visible sample (with a small headroom pad)
        // and the top near the NEWEST. Because samples are monotonically
        // increasing, this guarantees the curve rises diagonally across the
        // panel rather than flattening.
        var oldestR, newestR;
        if (nPts > 0) {
          oldestR = Lk.points[0];
          newestR = Lk.points[nPts - 1];
          // Enforce a minimum span so a young chart with a tiny range still
          // reads as having angle (avoids the line hugging chart center early)
          var span = newestR - oldestR;
          if (span < 0.6) {
            var midR = (oldestR + newestR) * 0.5;
            oldestR = midR - 0.3; newestR = midR + 0.3;
          }
        } else {
          oldestR = 3.8; newestR = 4.2;
        }
        var pad = (newestR - oldestR) * 0.18 + 0.2;
        var tMin = oldestR - pad;
        var tMax = newestR + pad;
        if (Lk.viewMin === undefined) { Lk.viewMin = tMin; Lk.viewMax = tMax; }
        Lk.viewMin += (tMin - Lk.viewMin) * 0.05;
        Lk.viewMax += (tMax - Lk.viewMax) * 0.05;
        function roasToY(r) { return chartBot - ((r - Lk.viewMin) / (Lk.viewMax - Lk.viewMin)) * (chartBot - chartTop); }
        var floorY = roasToY(floorRoas);
        // Determine live point x first (chart fills L→R, then scrolls L)
        var fillRightX = nPts > 0 ? (nPts - 1) * Lk.pxSpacing : 0;
        var isFilling = fillRightX < W;
        var liveXcomputed = isFilling ? fillRightX : (W - Lk.scroll);
        // Spawn floating $ events (only after we have data)
        if (nPts > 0) {
          Lk.eventTimer -= 1;
          if (Lk.eventTimer <= 0) {
            Lk.eventTimer = 24 + Math.floor(Math.random() * 24);
            var amt = Math.floor(280 + Math.random() * 1400);
            var lastP2 = Lk.points[Lk.points.length - 1];
            Lk.events.push({ amount: amt, x: liveXcomputed, y: roasToY(lastP2) - 6, life: 1 });
            Lk.revenue += amt;
          }
        }
        for (var ei = Lk.events.length - 1; ei >= 0; ei--) {
          var ev = Lk.events[ei];
          ev.y -= 0.7; ev.life -= 0.011;
          if (ev.life <= 0) Lk.events.splice(ei, 1);
        }
        // ─── Render ───
        // Outer-space backdrop (matches Stage 2 + Stage 4): nebula + stars
        if (!Lk.stars || Lk.starsW !== W || Lk.starsH !== H) {
          Lk.stars = []; Lk.starsW = W; Lk.starsH = H;
          var nLkStars = Math.round((W * H) / 1600);
          for (var sLk = 0; sLk < nLkStars; sLk++) {
            Lk.stars.push({
              x: Math.random() * W, y: Math.random() * H,
              r: Math.random() < 0.92 ? Math.random() * 0.7 + 0.3 : Math.random() * 1.4 + 1.2,
              tw: Math.random() * Math.PI * 2,
              base: 0.25 + Math.random() * 0.55,
              vx: (Math.random() - 0.5) * 0.04
            });
          }
        }
        var nebL = ctx.createRadialGradient(W*0.32, H*0.28, 0, W*0.32, H*0.28, Math.min(W,H)*0.85);
        nebL.addColorStop(0,    'rgba(146, 188, 221, 0.10)');
        nebL.addColorStop(0.35, 'rgba(120,  90,  50, 0.05)');
        nebL.addColorStop(1,    'rgba(0, 0, 0, 0)');
        ctx.fillStyle = nebL; ctx.fillRect(0, 0, W, H);
        var nebR = ctx.createRadialGradient(W*0.78, H*0.75, 0, W*0.78, H*0.75, Math.min(W,H)*0.7);
        nebR.addColorStop(0,   'rgba(80, 90, 130, 0.08)');
        nebR.addColorStop(0.4, 'rgba(40, 50, 80, 0.04)');
        nebR.addColorStop(1,   'rgba(0, 0, 0, 0)');
        ctx.fillStyle = nebR; ctx.fillRect(0, 0, W, H);
        for (var sLk2 = 0; sLk2 < Lk.stars.length; sLk2++) {
          var stL = Lk.stars[sLk2];
          stL.x += stL.vx;
          if (stL.x < -2) stL.x = W + 2;
          if (stL.x > W + 2) stL.x = -2;
          var twL = stL.base + Math.sin(t * 1.4 + stL.tw) * 0.28;
          twL = Math.max(0.05, Math.min(1, twL));
          if (stL.r > 1.0) {
            ctx.fillStyle = 'rgba(255, 245, 212, ' + (twL * 0.4) + ')';
            ctx.beginPath(); ctx.arc(stL.x, stL.y, stL.r * 2.6, 0, Math.PI*2); ctx.fill();
          }
          ctx.fillStyle = 'rgba(255, 245, 212, ' + twL + ')';
          ctx.beginPath(); ctx.arc(stL.x, stL.y, stL.r, 0, Math.PI*2); ctx.fill();
        }
        // Faint instrument grid (above stars, behind chart)
        ctx.strokeStyle = 'rgba(236,237,238,0.04)';
        ctx.lineWidth = 0.5;
        for (var gx = 0; gx <= W; gx += 32) {
          ctx.beginPath(); ctx.moveTo(gx, 0); ctx.lineTo(gx, H); ctx.stroke();
        }
        for (var gy = 0; gy <= H; gy += 32) {
          ctx.beginPath(); ctx.moveTo(0, gy); ctx.lineTo(W, gy); ctx.stroke();
        }
        // Floor target line — only draw if it's still inside the visible range
        if (floorRoas >= Lk.viewMin && floorRoas <= Lk.viewMax) {
          ctx.strokeStyle = 'rgba(146,188,221,0.55)';
          ctx.setLineDash([4, 5]); ctx.lineWidth = 1;
          ctx.beginPath();
          ctx.moveTo(0, floorY); ctx.lineTo(W, floorY);
          ctx.stroke();
          ctx.setLineDash([]);
          ctx.fillStyle = 'rgba(146,188,221,0.78)';
          ctx.font = '8px JetBrains Mono, monospace';
          ctx.textAlign = 'left';
          ctx.fillText('FLOOR · 4.00×', 10, floorY - 6);
        }
        // Build curve points. Two phases:
        //  • Fill (chart < W wide): samples sit at fixed x = i × pxSpacing,
        //    so the line grows from left edge rightward.
        //  • Scroll (chart full): newest anchored at x = W, older sweep left.
        var pathPts = [];
        for (var pi = 0; pi < nPts; pi++) {
          var x;
          if (isFilling) {
            x = pi * Lk.pxSpacing;
          } else {
            var iFromRight = (nPts - 1) - pi;
            x = W - iFromRight * Lk.pxSpacing - Lk.scroll;
          }
          if (x < -10 || x > W + 10) continue;
          pathPts.push({ x: x, y: roasToY(Lk.points[pi]) });
        }
        // Need ≥ 2 points to draw a curve
        if (pathPts.length >= 2) {
          // Smooth-path drawer: midpoint quadratic-bezier smoothing
          function tracePath(pts) {
            ctx.moveTo(pts[0].x, pts[0].y);
            for (var ii = 1; ii < pts.length - 1; ii++) {
              var midX = (pts[ii].x + pts[ii+1].x) / 2;
              var midY = (pts[ii].y + pts[ii+1].y) / 2;
              ctx.quadraticCurveTo(pts[ii].x, pts[ii].y, midX, midY);
            }
            ctx.lineTo(pts[pts.length-1].x, pts[pts.length-1].y);
          }
          // Area fill
          var areaGrad = ctx.createLinearGradient(0, chartTop, 0, chartBot);
          areaGrad.addColorStop(0, 'rgba(146,188,221,0.42)');
          areaGrad.addColorStop(1, 'rgba(146,188,221,0)');
          ctx.fillStyle = areaGrad;
          ctx.beginPath();
          ctx.moveTo(pathPts[0].x, chartBot);
          ctx.lineTo(pathPts[0].x, pathPts[0].y);
          for (var ii2 = 1; ii2 < pathPts.length - 1; ii2++) {
            var mx = (pathPts[ii2].x + pathPts[ii2+1].x) / 2;
            var my = (pathPts[ii2].y + pathPts[ii2+1].y) / 2;
            ctx.quadraticCurveTo(pathPts[ii2].x, pathPts[ii2].y, mx, my);
          }
          ctx.lineTo(pathPts[pathPts.length-1].x, pathPts[pathPts.length-1].y);
          ctx.lineTo(pathPts[pathPts.length-1].x, chartBot);
          ctx.closePath();
          ctx.fill();
          // Curve line
          ctx.strokeStyle = 'rgba(235,217,168,0.95)';
          ctx.lineWidth = 1.8;
          ctx.lineCap = 'round'; ctx.lineJoin = 'round';
          ctx.shadowColor = 'rgba(255,245,212,0.7)'; ctx.shadowBlur = 9;
          ctx.beginPath();
          tracePath(pathPts);
          ctx.stroke();
          ctx.shadowBlur = 0;
        }
        // Live point at right edge (only after we have data)
        if (pathPts.length >= 1) {
          var liveX = pathPts[pathPts.length - 1].x;
          var liveY = pathPts[pathPts.length - 1].y;
          var pulseR = 6 + Math.sin(t * 6) * 2;
          ctx.strokeStyle = 'rgba(255,245,212,0.4)';
          ctx.lineWidth = 0.8;
          ctx.beginPath(); ctx.arc(liveX, liveY, pulseR, 0, Math.PI*2); ctx.stroke();
          ctx.fillStyle = 'rgba(255,245,212,1)';
          ctx.shadowColor = 'rgba(255,245,212,0.95)'; ctx.shadowBlur = 14;
          ctx.beginPath(); ctx.arc(liveX, liveY, 3.6, 0, Math.PI*2); ctx.fill();
          ctx.shadowBlur = 0;
        }
        // Floating +$X events
        ctx.font = '10px JetBrains Mono, monospace';
        ctx.textAlign = 'right';
        for (var ei2 = 0; ei2 < Lk.events.length; ei2++) {
          var ev2 = Lk.events[ei2];
          ctx.fillStyle = 'rgba(255,245,212,' + ev2.life + ')';
          ctx.shadowColor = 'rgba(255,245,212,' + (ev2.life * 0.6) + ')'; ctx.shadowBlur = 4;
          ctx.fillText('+$' + ev2.amount.toLocaleString(), ev2.x, ev2.y);
          ctx.shadowBlur = 0;
        }
        // Revenue counter — moved down from the top of the canvas
        // (was y=14/36) where it was overlapping the SVG's TARGET
        // label + the chart's top axis. Now sits in the upper-right
        // mid-zone, clear of the chart annotations behind.
        ctx.fillStyle = 'rgba(146,188,221,0.85)';
        ctx.font = '8px JetBrains Mono, monospace';
        ctx.fillText('TOTAL REVENUE', W - 14, 78);
        ctx.font = '20px JetBrains Mono, monospace';
        ctx.fillStyle = 'rgba(235,217,168,1)';
        ctx.fillText('$' + Lk.revenue.toLocaleString(), W - 14, 102);
        // Current ROAS (bottom-right) — only after we have data
        if (nPts > 0) {
          var currentRoas = Lk.points[Lk.points.length - 1];
          ctx.font = '8px JetBrains Mono, monospace';
          ctx.fillStyle = 'rgba(146,188,221,0.85)';
          ctx.fillText('ROAS', W - 14, H - 30);
          ctx.font = '22px JetBrains Mono, monospace';
          ctx.fillStyle = 'rgba(235,217,168,1)';
          ctx.fillText(currentRoas.toFixed(2) + '×', W - 14, H - 8);
        }
        ctx.textAlign = 'left';
      }

    }
    skGateLoop(canvas, tick);
  });
})();

// ═══ Scroll-driven graph ═══
(function() {
  var section = document.getElementById('graphSection');
  var roasPath = document.getElementById('roasPath');
  var roasArea = document.getElementById('roasArea');
  var roasPoint = document.getElementById('roasPoint');
  if (!section || !roasPath) return;

  var W = 1000, H = 320;
  // Build curve points: ROAS climbs from 1.2 to 4.5 over 90 days
  var pts = [];
  for (var i = 0; i <= 90; i++) {
    var p = i/90;
    // Ease: slow start, steep middle, plateau
    var roas = 1.2 + (Math.pow(p, 1.4) * 3.4) - Math.sin(p*Math.PI*4) * 0.15;
    var x = (i/90) * W;
    var y = H - ((roas - 1) / 4) * (H - 30) - 10;
    pts.push({ x: x, y: y, day: i, roas: roas });
  }

  function pathTo(n) {
    if (n < 1) return '';
    var d = 'M' + pts[0].x + ',' + pts[0].y;
    for (var i = 1; i < n; i++) d += ' L' + pts[i].x + ',' + pts[i].y;
    return d;
  }
  function areaTo(n) {
    if (n < 2) return '';
    var d = 'M' + pts[0].x + ',' + H;
    for (var i = 0; i < n; i++) d += ' L' + pts[i].x + ',' + pts[i].y;
    d += ' L' + pts[n-1].x + ',' + H + ' Z';
    return d;
  }

  var rDay = document.getElementById('rDay');
  var rSpend = document.getElementById('rSpend');
  var rRoas = document.getElementById('rRoas');
  var rDelta = document.getElementById('rDelta');
  var rRev = document.getElementById('rRev');
  var roasHalo = document.getElementById('roasHalo');
  var crossH = document.getElementById('crossH');
  var crossV = document.getElementById('crossV');
  var FLOOR = 4.0; // contracted ROAS floor

  function onScroll() {
    var rect = section.getBoundingClientRect();
    var totalH = section.offsetHeight - window.innerHeight;
    if (totalH <= 0) return;
    var p = Math.max(0, Math.min(1, -rect.top / totalH));
    var n = Math.max(1, Math.round(p * pts.length));
    roasPath.setAttribute('d', pathTo(n));
    roasArea.setAttribute('d', areaTo(n));
    roasArea.setAttribute('opacity', p > 0 ? 1 : 0);
    var last = pts[Math.min(n-1, pts.length-1)];
    var visible = p > 0.05 ? 1 : 0;
    roasPoint.setAttribute('cx', last.x);
    roasPoint.setAttribute('cy', last.y);
    roasPoint.setAttribute('opacity', visible);
    roasHalo.setAttribute('cx', last.x);
    roasHalo.setAttribute('cy', last.y);
    roasHalo.setAttribute('opacity', visible * 0.85);
    crossH.setAttribute('y1', last.y); crossH.setAttribute('y2', last.y);
    crossH.setAttribute('opacity', visible);
    crossV.setAttribute('x1', last.x); crossV.setAttribute('x2', last.x);
    crossV.setAttribute('opacity', visible);

    var spend = 15 + p*0.8;     // mostly flat
    var revenue = spend * last.roas;
    var delta = last.roas - FLOOR;
    rDay.textContent = last.day;
    rSpend.textContent = '$' + spend.toFixed(1) + 'k';
    rRoas.textContent = last.roas.toFixed(2) + '×';
    rDelta.textContent = (delta >= 0 ? '+' : '') + delta.toFixed(2) + '×';
    rRev.textContent = '$' + revenue.toFixed(0) + 'k';
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

// ═══ Cockpit instrument gauges ═══
(function() {
  document.querySelectorAll('.instrument-canvas').forEach(function(canvas) {
    var ctx = canvas.getContext('2d');
    var gauge = canvas.dataset.gauge;
    var W=0, H=0, dpr=Math.min(window.devicePixelRatio||1, 2);
    function resize() { var r=canvas.getBoundingClientRect(); W=r.width; H=r.height; canvas.width=W*dpr; canvas.height=H*dpr; ctx.setTransform(dpr,0,0,dpr,0,0); }
    resize(); window.addEventListener('resize', resize);
    var t = Math.random() * 100;
    var state = null;

    function tick() {
      t += 0.012;
      ctx.clearRect(0, 0, W, H);
      var cx = W/2, cy = H/2;

      if (gauge === 'signal-bars') {
        // Deterministic flowing signal — pure time-based math like Instrument 6.
        // No samples, no spawn/prune. Three sine harmonics combine for organic
        // motion that drifts continuously leftward.
        var baseY = H - 16;
        var amp = (H - 50) * 0.5;
        function signalY(x) {
          var phase = (x * 0.04) - t * 1.2;
          return baseY - amp * (
            0.55
            + Math.sin(phase) * 0.30
            + Math.sin(phase * 1.7 + t * 0.4) * 0.14
            + Math.sin(phase * 0.5 - t * 0.3) * 0.10
          );
        }
        // Filled area beneath
        var areaGrad = ctx.createLinearGradient(0, 12, 0, baseY);
        areaGrad.addColorStop(0, 'rgba(235,217,168,0.55)');
        areaGrad.addColorStop(1, 'rgba(160,134,73,0.04)');
        ctx.fillStyle = areaGrad;
        ctx.beginPath();
        ctx.moveTo(12, baseY);
        for (var sx = 12; sx <= W - 12; sx += 2) ctx.lineTo(sx, signalY(sx));
        ctx.lineTo(W - 12, baseY);
        ctx.closePath();
        ctx.fill();
        // Curve stroke with cream glow
        ctx.strokeStyle = 'rgba(235,217,168,0.92)';
        ctx.lineWidth = 1.4;
        ctx.lineCap = 'round'; ctx.lineJoin = 'round';
        ctx.shadowColor = 'rgba(255,245,212,0.55)'; ctx.shadowBlur = 6;
        ctx.beginPath();
        for (var sx2 = 12; sx2 <= W - 12; sx2 += 2) {
          var sy2 = signalY(sx2);
          if (sx2 === 12) ctx.moveTo(sx2, sy2); else ctx.lineTo(sx2, sy2);
        }
        ctx.stroke();
        ctx.shadowBlur = 0;
        // Edge fade gradients
        var lF = ctx.createLinearGradient(0, 0, 28, 0);
        lF.addColorStop(0, 'rgba(4,5,8,1)'); lF.addColorStop(1, 'rgba(4,5,8,0)');
        ctx.fillStyle = lF; ctx.fillRect(0, 0, 28, H);
        var rF = ctx.createLinearGradient(W - 28, 0, W, 0);
        rF.addColorStop(0, 'rgba(4,5,8,0)'); rF.addColorStop(1, 'rgba(4,5,8,1)');
        ctx.fillStyle = rF; ctx.fillRect(W - 28, 0, 28, H);
        // Center reference line
        ctx.strokeStyle = 'rgba(146,188,221,0.16)';
        ctx.setLineDash([2, 4]); ctx.lineWidth = 0.6;
        ctx.beginPath(); ctx.moveTo(28, cy + 6); ctx.lineTo(W - 28, cy + 6); ctx.stroke();
        ctx.setLineDash([]);
      }
      else if (gauge === 'rpm-dial') {
        // Circular gauge with hunting needle and tick marks
        var r = Math.min(W, H) * 0.36;
        var dy = 14;
        // Outer arc
        ctx.strokeStyle = 'rgba(146,188,221,0.55)';
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.arc(cx, cy + dy, r, Math.PI * 0.85, Math.PI * 2.15, false);
        ctx.stroke();
        // Tick marks
        for (var ti = 0; ti <= 12; ti++) {
          var a = Math.PI * 0.85 + (ti / 12) * Math.PI * 1.3;
          var inner = r - (ti % 3 === 0 ? 8 : 4);
          ctx.strokeStyle = 'rgba(146,188,221,' + (ti % 3 === 0 ? 0.85 : 0.4) + ')';
          ctx.lineWidth = ti % 3 === 0 ? 1.2 : 0.6;
          ctx.beginPath();
          ctx.moveTo(cx + Math.cos(a) * inner, cy + dy + Math.sin(a) * inner);
          ctx.lineTo(cx + Math.cos(a) * r, cy + dy + Math.sin(a) * r);
          ctx.stroke();
        }
        // Needle: hunting around 70%
        var p = 0.7 + Math.sin(t * 1.2) * 0.08 + Math.sin(t * 3.4) * 0.03;
        var na = Math.PI * 0.85 + p * Math.PI * 1.3;
        ctx.strokeStyle = 'rgba(255,245,212,0.95)';
        ctx.lineWidth = 1.5;
        ctx.shadowColor = 'rgba(255,245,212,0.95)'; ctx.shadowBlur = 8;
        ctx.beginPath();
        ctx.moveTo(cx, cy + dy);
        ctx.lineTo(cx + Math.cos(na) * (r - 6), cy + dy + Math.sin(na) * (r - 6));
        ctx.stroke();
        ctx.shadowBlur = 0;
        // Hub
        ctx.fillStyle = 'rgba(235,217,168,0.95)';
        ctx.beginPath(); ctx.arc(cx, cy + dy, 3.5, 0, Math.PI*2); ctx.fill();
        // Center readout
        ctx.fillStyle = 'rgba(235,217,168,1)';
        ctx.font = 'bold 18px JetBrains Mono, monospace';
        ctx.textAlign = 'center';
        ctx.fillText((1 + p * 3.5).toFixed(2) + '×', cx, cy - r * 0.35);
        ctx.textAlign = 'left';
      }
      else if (gauge === 'honeycomb') {
        // 7 hex cells in honeycomb pattern; one lit at a time, advancing
        if (!state) state = { activeIdx: 0, holdT: 0 };
        state.holdT += 1;
        if (state.holdT > 40) { state.holdT = 0; state.activeIdx = (state.activeIdx + 1) % 7; }
        var hexR = Math.min(W, H) * 0.16;
        var positions = [{ x: cx, y: cy }];
        for (var hi = 0; hi < 6; hi++) {
          var hexAng = Math.PI / 6 + hi * Math.PI / 3;
          positions.push({
            x: cx + Math.cos(hexAng) * hexR * 1.78,
            y: cy + Math.sin(hexAng) * hexR * 1.78
          });
        }
        for (var pi = 0; pi < positions.length; pi++) {
          var pp = positions[pi];
          var isActive = pi === state.activeIdx;
          ctx.beginPath();
          for (var si = 0; si < 6; si++) {
            var sAng = Math.PI / 6 + si * Math.PI / 3;
            var hx = pp.x + Math.cos(sAng) * hexR;
            var hy = pp.y + Math.sin(sAng) * hexR;
            if (si === 0) ctx.moveTo(hx, hy); else ctx.lineTo(hx, hy);
          }
          ctx.closePath();
          if (isActive) {
            ctx.fillStyle = 'rgba(146,188,221,0.32)';
            ctx.shadowColor = 'rgba(255,245,212,0.85)'; ctx.shadowBlur = 14;
            ctx.fill();
            ctx.shadowBlur = 0;
          }
          ctx.strokeStyle = isActive ? 'rgba(255,245,212,0.95)' : 'rgba(146,188,221,0.45)';
          ctx.lineWidth = isActive ? 1.5 : 0.8;
          ctx.stroke();
        }
      }
      else if (gauge === 'data-feed') {
        // Scrolling mono text data feed (search queries with +/- verdicts)
        if (!state) {
          state = {
            lines: [
              '+ "best plumber near me"',
              '- "free repair guide"',
              '+ "emergency hvac"',
              '- "diy install"',
              '+ "24h locksmith"',
              '- "training course"',
              '+ "weekend electrician"',
              '- "youtube how to"',
              '+ "same day install"',
              '- "review only"',
              '+ "after hours svc"',
              '- "wholesale parts"'
            ],
            scrollY: 0
          };
        }
        state.scrollY = (state.scrollY + 0.35) % (state.lines.length * 14);
        ctx.font = '10px JetBrains Mono, monospace';
        ctx.textAlign = 'left';
        for (var li = 0; li < state.lines.length * 2; li++) {
          var lineY = (li * 14) - state.scrollY + 6;
          if (lineY < -14 || lineY > H + 14) continue;
          var line = state.lines[li % state.lines.length];
          var isPlus = line.charAt(0) === '+';
          ctx.fillStyle = isPlus ? 'rgba(235,217,168,0.85)' : 'rgba(160,134,73,0.5)';
          ctx.fillText(line, 14, lineY);
        }
        // Top/bottom fade overlays
        var topF = ctx.createLinearGradient(0, 0, 0, 30);
        topF.addColorStop(0, 'rgba(4,5,8,1)'); topF.addColorStop(1, 'rgba(4,5,8,0)');
        ctx.fillStyle = topF; ctx.fillRect(0, 0, W, 30);
        var botF = ctx.createLinearGradient(0, H - 30, 0, H);
        botF.addColorStop(0, 'rgba(4,5,8,0)'); botF.addColorStop(1, 'rgba(4,5,8,1)');
        ctx.fillStyle = botF; ctx.fillRect(0, H - 30, W, 30);
      }
      else if (gauge === 'radar') {
        // Radar with rotating sweep, target dots flash as sweep passes
        var rad = Math.min(W, H) * 0.42;
        ctx.strokeStyle = 'rgba(146,188,221,0.18)';
        ctx.lineWidth = 0.6;
        for (var ri = 1; ri <= 3; ri++) {
          ctx.beginPath(); ctx.arc(cx, cy, rad * ri / 3, 0, Math.PI*2); ctx.stroke();
        }
        ctx.beginPath(); ctx.moveTo(cx - rad, cy); ctx.lineTo(cx + rad, cy); ctx.stroke();
        ctx.beginPath(); ctx.moveTo(cx, cy - rad); ctx.lineTo(cx, cy + rad); ctx.stroke();
        var sweepAng = (t * 1.4) % (Math.PI * 2);
        // Sweep with trailing fade
        for (var sa = 0; sa < 12; sa++) {
          var ang = sweepAng - (sa / 12) * Math.PI * 0.5;
          var alpha = (1 - sa / 12) * 0.7;
          ctx.strokeStyle = 'rgba(146,188,221,' + alpha + ')';
          ctx.lineWidth = 1;
          ctx.beginPath();
          ctx.moveTo(cx, cy);
          ctx.lineTo(cx + Math.cos(ang) * rad, cy + Math.sin(ang) * rad);
          ctx.stroke();
        }
        if (!state) {
          state = { dots: [] };
          for (var di = 0; di < 5; di++) {
            state.dots.push({
              ang: Math.random() * Math.PI * 2,
              dist: 0.3 + Math.random() * 0.6,
              flash: 0
            });
          }
        }
        for (var di2 = 0; di2 < state.dots.length; di2++) {
          var d = state.dots[di2];
          var dDelta = ((sweepAng - d.ang) % (Math.PI * 2) + Math.PI * 2) % (Math.PI * 2);
          if (dDelta < 0.08) d.flash = 1;
          d.flash *= 0.94;
          var ddx = cx + Math.cos(d.ang) * rad * d.dist;
          var ddy = cy + Math.sin(d.ang) * rad * d.dist;
          ctx.fillStyle = 'rgba(255,245,212,' + (0.32 + d.flash * 0.65) + ')';
          if (d.flash > 0.1) { ctx.shadowColor = 'rgba(255,245,212,0.95)'; ctx.shadowBlur = 10; }
          ctx.beginPath(); ctx.arc(ddx, ddy, 2 + d.flash * 1.6, 0, Math.PI*2); ctx.fill();
          ctx.shadowBlur = 0;
        }
      }
      else if (gauge === 'horizon-meter') {
        // ─── Vertical thermometer gauge — fill rises above the FLOOR tick
        //     and oscillates gently. Stays above the floor at all times. ───
        var barW = 26;
        var barX = W * 0.30 - barW / 2;
        var barTop = 30;
        var barBot = H - 14;
        var barH = barBot - barTop;
        var floorY = barTop + barH * 0.46;  // FLOOR tick ~46% from top
        // Live fill top — slowly oscillating, always above floor
        var fillTopBase = barTop + barH * 0.20;
        var fillTop = fillTopBase + Math.sin(t * 0.8) * 4 + Math.sin(t * 2.3 + 1.2) * 2;
        // Bar shell
        ctx.fillStyle = 'rgba(7, 8, 11, 0.55)';
        ctx.fillRect(barX, barTop, barW, barH);
        ctx.strokeStyle = 'rgba(146, 188, 221, 0.4)';
        ctx.lineWidth = 1;
        ctx.strokeRect(barX + 0.5, barTop + 0.5, barW - 1, barH - 1);
        // Tick marks on left side
        for (var ti = 0; ti <= 10; ti++) {
          var ty = barTop + (ti / 10) * barH;
          var tlen = ti % 2 === 0 ? 7 : 3;
          ctx.strokeStyle = 'rgba(146, 188, 221, ' + (ti % 2 === 0 ? 0.7 : 0.35) + ')';
          ctx.lineWidth = ti % 2 === 0 ? 1 : 0.6;
          ctx.beginPath();
          ctx.moveTo(barX - tlen - 1, ty);
          ctx.lineTo(barX - 1, ty);
          ctx.stroke();
        }
        // Fill (champagne gradient, fills from fillTop to barBot)
        var fillGrad = ctx.createLinearGradient(0, fillTop, 0, barBot);
        fillGrad.addColorStop(0,   'rgba(255, 245, 212, 0.95)');
        fillGrad.addColorStop(0.4, 'rgba(146, 188, 221, 0.85)');
        fillGrad.addColorStop(1,   'rgba(160, 134, 73, 0.45)');
        ctx.fillStyle = fillGrad;
        ctx.fillRect(barX + 2, fillTop, barW - 4, barBot - fillTop - 1);
        // Bright cream cap at fill top with glow
        ctx.fillStyle = 'rgba(255, 245, 212, 1)';
        ctx.shadowColor = 'rgba(255, 245, 212, 0.95)'; ctx.shadowBlur = 10;
        ctx.fillRect(barX + 2, fillTop - 1, barW - 4, 2.5);
        ctx.shadowBlur = 0;
        // FLOOR tick — dashed horizontal line crossing through the bar area
        ctx.strokeStyle = 'rgba(146, 188, 221, 0.65)';
        ctx.setLineDash([3, 4]); ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.moveTo(barX - 12, floorY);
        ctx.lineTo(W - 14, floorY);
        ctx.stroke();
        ctx.setLineDash([]);
        // FLOOR label (to the right of the bar, aligned to floor tick)
        ctx.fillStyle = 'rgba(146, 188, 221, 0.85)';
        ctx.font = '8px JetBrains Mono, monospace';
        ctx.textAlign = 'left';
        ctx.fillText('TARGET · 4.00×', barX + barW + 14, floorY - 5);
        // Live ROAS readout (large, anchored next to fill top)
        var fillProgress = (barBot - fillTop) / barH;
        var liveRoas = 1 + fillProgress * 4.5;  // ~1× → ~5.5×
        ctx.fillStyle = 'rgba(235, 217, 168, 1)';
        ctx.font = 'bold 18px JetBrains Mono, monospace';
        ctx.shadowColor = 'rgba(255, 245, 212, 0.5)'; ctx.shadowBlur = 5;
        ctx.fillText(liveRoas.toFixed(2) + '×', barX + barW + 14, fillTop + 8);
        ctx.shadowBlur = 0;
        // ROAS label above the readout
        ctx.fillStyle = 'rgba(146, 188, 221, 0.65)';
        ctx.font = '8px JetBrains Mono, monospace';
        ctx.fillText('ROAS', barX + barW + 14, fillTop - 5);
      }

    }
    skGateLoop(canvas, tick);
  });
})();

// ═══ Magnetic CTAs ═══
(function() {
  if (window.matchMedia('(pointer: coarse)').matches) return;
  document.querySelectorAll('[data-magnetic]').forEach(function(btn) {
    btn.addEventListener('mousemove', function(e) {
      var r = btn.getBoundingClientRect();
      var x = e.clientX - (r.left + r.width/2);
      var y = e.clientY - (r.top + r.height/2);
      btn.style.transform = 'translate(' + (x*0.18) + 'px,' + (y*0.18) + 'px)';
    });
    btn.addEventListener('mouseleave', function() { btn.style.transform = ''; });
  });
})();

// ═══ Marquee — duplicate to seamless loop ═══
(function() {
  var track = document.getElementById('marqueeTrack');
  if (!track) return;
  track.innerHTML += track.innerHTML;
})();

} // end __skyfallPmaxLoaded guard
